/** @format */
import { round } from 'lodash';

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type FormatAsCurrencyOptions = Omit<
    Intl.NumberFormatOptions,
    'maximumFractionDigits' | 'minimumFractionDigits'
> & {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
    trailingZeros?: boolean;
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
    formatWithGrouping?: boolean;
};

export function formatAsCurrency(
    locale: string,
    currency: string,
    formatWithGrouping?: boolean
) {
    // Ensure locale is normalized
    const normalizedLocale = locale.replace('_', '-');

    // Define a list of locales where currency grouping should be ignored
    // and numbers should be shown as plain numbers.
    const localesToIgnoreGrouping = ['en-EU'];
    const shouldFormatWithGrouping =
        !localesToIgnoreGrouping.includes(normalizedLocale);

    return (
        value: number,
        {
            trailingZeros = true,
            ...additionalOptions
        }: FormatAsCurrencyOptions = {}
    ): string => {
        const options: Intl.NumberFormatOptions = {
            style: 'currency',
            currency,
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- Legacy code: do not use as an example.
            useGrouping: formatWithGrouping || shouldFormatWithGrouping,
            ...additionalOptions,
        };

        // If the number is an integer, we do not want to show trailing zeros
        // TOUCH AND CHANGE:
        // eslint-disable-next-line @typescript-eslint/prefer-includes -- Legacy code: do not use as an example.
        if (!trailingZeros && value.toString().indexOf('.') < 0) {
            options.maximumFractionDigits = 0;
            options.minimumFractionDigits = 0;
        }

        return value.toLocaleString(normalizedLocale, options);
    };
}

/**
 * Formats a number into a 'pretty' decimal (includes commas)
 */
export function formatAsDecimal(locale: string, number: number): string {
    // Ensure locale is normalized
    const normalizedLocale = locale.replace('_', '-');

    return number.toLocaleString(normalizedLocale, {
        style: 'decimal',
    });
}

export function centToDecimal(value: number): number {
    return value / 100;
}

export function decimalToCent(value: number): number {
    return round(value * 100);
}

export function getCurrencySymbol(locale: string, currency: string) {
    const normalizedLocale = locale.replace('_', '-');
    return (0)
        .toLocaleString(normalizedLocale, {
            style: 'currency',
            currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        })
        .replace(/\d/g, '')
        .trim();
}
